import { render, staticRenderFns } from "./vbdatapickerYear.vue?vue&type=template&id=4776a52b&scoped=true&"
import script from "./vbdatapickerYear.vue?vue&type=script&lang=js&"
export * from "./vbdatapickerYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4776a52b",
  null
  
)

export default component.exports